export const GET_PAYMENT_HISTORY = 'GET_PAYMENT_HISTORY'
export const GET_PAYMENT_METHODS = 'GET_PAYMENT_METHODS'
export const GET_USER_PAYMENT_METHODS = 'GET_USER_PAYMENT_METHODS'
export const GET_INVOICES = 'GET_INVOICES'
export const UNBLOCK_ALL_INVOICES = 'UNBLOCK_ALL_INVOICES'
export const UNBLOCK_INVOICE = 'UNBLOCK_INVOICE'
export const UNBLOCK_INVOICES = 'UNBLOCK_INVOICES'
export const BLOCK_INVOICE = 'BLOCK_INVOICE'
export const BLOCK_INVOICES = 'BLOCK_INVOICES'
export const GET_CYBERSOURCE_DETAILS = 'GET_CYBERSOURCE_DETAILS'
export const GET_USER_CYBERSOURCE_DETAILS = 'GET_USER_CYBERSOURCE_DETAILS'
export const GET_AUTO_PAY_DETAILS = 'GET_AUTO_PAY_DETAILS'
export const GET_SINGLE_INVOICE = 'GET_SINGLE_INVOICE'
export const ENFORCE_INVOICE_PORTAL_CONTEXT = 'ENFORCE_INVOICE_PORTAL_CONTEXT'
export const ENFORCE_BILLING_PORTAL_CONTEXT = 'ENFORCE_BILLING_PORTAL_CONTEXT'
export const MAKE_PAYMENT = 'MAKE_PAYMENT'
export const SETUP_RECURRING_PAYMENTS = 'SETUP_RECURRING_PAYMENTS'
export const DELETE_PAYMENT_METHOD = 'DELETE_PAYMENT_METHOD'
export const DELETE_USER_PAYMENT_METHOD = 'DELETE_USER_PAYMENT_METHOD'
export const UPDATE_DEFAULT_USER_PAYMENT_METHOD = 'UPDATE_DEFAULT_USER_PAYMENT_METHOD'
export const GET_SUBGROUP_DETAILS = 'GET_SUBGROUP_DETAILS'
export const GET_CASH_ON_ACCOUNTS = 'GET_CASH_ON_ACCOUNTS'
export const GET_CYBERSOURCE_ONETIME_PAYMENT_DETAILS = 'GET_CYBERSOURCE_ONETIME_PAYMENT_DETAILS'
export const GET_PAYMENT_HISTORY_CONFIGURATION = 'GET_PAYMENT_HISTORY_CONFIGURATION'
export const GET_INVOICE_PAYMENT_HISTORY = 'GET_INVOICE_PAYMENT_HISTORY'
export const GET_PAYMENT_LOBS = 'GET_PAYMENT_LOBS'
